// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/navigation.js
import BaseComponent from "./base_component"
export { default as Sidebar } from "./sidebar"
export { Navigation }

export default class Navigation extends BaseComponent {
  static componentName = "navigation"
  static defaults = { groupsAutoCollapse: false }

  constructor(element, config = {}) {
    super(element, config)
    element.querySelectorAll(".nav-group").forEach((group) => this.syncExpanded(group))
    this.listen(element, "click", (event) => {
      const toggler = event.target.closest(".nav-group-toggle")
      if (!toggler || toggler.closest('[data-controller~="coreui-navigation"]') !== element) return
      event.preventDefault()
      this.toggle(toggler.parentElement)
    })
  }

  toggle(group) {
    if (this.config.groupsAutoCollapse && !group.classList.contains("show")) {
      ;[...group.parentElement.children]
        .filter((item) => item !== group && item.matches(".nav-group.show"))
        .forEach((item) => {
          item.classList.remove("show")
          this.syncExpanded(item)
        })
    }
    group.classList.toggle("show")
    this.syncExpanded(group)
  }
  syncExpanded(group) {
    const show = group.classList.contains("show")
    group.setAttribute("aria-expanded", show)
    group.querySelector(":scope > .nav-group-toggle")?.setAttribute("aria-expanded", show)
  }
}
